// Bootstrap JS
// @devnote comment this line if you plan to
// use the CDN version of boostrap js
import "bootstrap";
import "./lib/products.ts";
import "./lib/splide.ts";
import { watchScroll } from './lib/scroll';
import { silenceModalsOnDismiss } from './lib/video';
/**
 * Benchmarking
 */
var timeStart = window.performance.now();
var timeEnd;
document.addEventListener('DOMContentLoaded', function () {
    /**
     * Load Webfonts
     */
    // loadWebfonts(webfonts);
    // Do stuff...
    watchScroll();
    silenceModalsOnDismiss();
    /**
     * Benchmarking reporting
     */
    timeEnd = window.performance.now();
    console.info("Execution time: ".concat(timeEnd - timeStart, "ms after DOMContentLoaded."));
});
